var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoodPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "food_1_",
    "data-name": "food (1)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9932",
    "data-name": "Group 9932",
    transform: "translate(1.635 1.635)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 63,
    cy: 63,
    r: 63,
    transform: "translate(0.365 0.365)",
    fill: "#8ceef9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9933",
    "data-name": "Group 9933",
    transform: "translate(84.1 72.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11602",
    "data-name": "Path 11602",
    d: "M323.472,280.076l.91,8.19a1.111,1.111,0,0,0,1.976.572l.182-.234a1.109,1.109,0,0,1,1.95.442l.988,4.16a1.113,1.113,0,0,0,2.054.286,1.1,1.1,0,0,1,1.638-.338l3.9,2.99a1.111,1.111,0,0,0,1.716-1.274l-1.794-4.576a1.105,1.105,0,0,1,.78-1.482,1.113,1.113,0,0,0,.286-2.054l-3.718-2.08a1.117,1.117,0,0,1,.13-2l.286-.13a1.114,1.114,0,0,0,0-2.054l-7.618-3.146a1.1,1.1,0,0,0-1.092.13l-2.132,1.612a1.009,1.009,0,0,0-.442.988Z",
    transform: "translate(-323.462 -277.257)",
    fill: "#0abfb2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9934",
    "data-name": "Group 9934",
    transform: "translate(82.844 70.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11603",
    "data-name": "Path 11603",
    d: "M334.172,293.928a2.3,2.3,0,0,1-1.456-.494L329,290.575a2.4,2.4,0,0,1-4.316-.806L323.8,286a2.4,2.4,0,0,1-2.5.754,2.431,2.431,0,0,1-1.742-2.054l-.91-8.19a2.373,2.373,0,0,1,.936-2.184l2.132-1.612a2.421,2.421,0,0,1,2.366-.312l7.618,3.146a2.405,2.405,0,0,1,.052,4.42l3.38,1.9a2.359,2.359,0,0,1,1.2,2.444,2.4,2.4,0,0,1-1.612,1.95l1.716,4.368a2.436,2.436,0,0,1-2.262,3.3Zm-5.252-6.058a2.458,2.458,0,0,1,1.456.494l3.354,2.574-1.534-3.926a2.447,2.447,0,0,1,.1-2,2.507,2.507,0,0,1,1.17-1.092l-3.354-1.872a2.429,2.429,0,0,1,.13-4.29l-7.1-2.912-1.95,1.482.858,7.644a2.409,2.409,0,0,1,2.314-.754,2.379,2.379,0,0,1,1.82,1.794l.884,3.744a2.354,2.354,0,0,1,1.352-.806A1.766,1.766,0,0,1,328.92,287.871Z",
    transform: "translate(-318.633 -272.225)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9935",
    "data-name": "Group 9935",
    transform: "translate(52.254 79.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11604",
    "data-name": "Path 11604",
    d: "M214.165,325.56l1.43-8.554a1.174,1.174,0,0,0-1.846-1.144l-.26.182a1.165,1.165,0,0,1-1.846-.988l.208-4.472a1.158,1.158,0,0,0-1.976-.884,1.182,1.182,0,0,1-1.768-.13l-3.068-4.134a1.171,1.171,0,0,0-2.106.806l.494,5.148a1.16,1.16,0,0,1-1.222,1.274,1.158,1.158,0,0,0-.884,1.976l3.146,3.172a1.168,1.168,0,0,1-.7,1.976l-.338.026a1.172,1.172,0,0,0-.6,2.08l6.812,5.382a1.2,1.2,0,0,0,1.144.182l2.626-1.014a1.06,1.06,0,0,0,.754-.884Z",
    transform: "translate(-200.978 -304.957)",
    fill: "#0abfb2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9936",
    "data-name": "Group 9936",
    transform: "translate(51.001 77.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11605",
    "data-name": "Path 11605",
    d: "M206.854,325.111a2.54,2.54,0,0,1-1.534-.52l-6.812-5.382a2.475,2.475,0,0,1,1.274-4.394h.052l-2.964-2.99a2.46,2.46,0,0,1,1.716-4.186l-.494-4.992a2.468,2.468,0,0,1,1.56-2.548,2.4,2.4,0,0,1,2.86.832l2.99,4.03a2.466,2.466,0,0,1,4.082,1.976l-.182,4.186.052-.026a2.475,2.475,0,0,1,3.9,2.392l-1.43,8.554a2.5,2.5,0,0,1-1.534,1.9l-2.626,1.014A2.911,2.911,0,0,1,206.854,325.111Zm-6.474-7.748,6.474,5.122,2.47-.962,1.378-8.164a2.462,2.462,0,0,1-2.626.182,2.49,2.49,0,0,1-1.3-2.288l.182-4.16a2.415,2.415,0,0,1-1.69.494,2.467,2.467,0,0,1-1.794-.988l-2.782-3.744.468,4.654a2.473,2.473,0,0,1-2.262,2.7l2.938,2.964a2.441,2.441,0,0,1,.572,2.548A2.382,2.382,0,0,1,200.38,317.363Z",
    transform: "translate(-196.157 -299.922)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9937",
    "data-name": "Group 9937",
    transform: "translate(33.28 11.154)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_192",
    "data-name": "Ellipse 192",
    cx: 31.668,
    cy: 31.668,
    r: 31.668,
    fill: "#ffece9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9938",
    "data-name": "Group 9938",
    transform: "translate(62.137 20.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11606",
    "data-name": "Path 11606",
    d: "M240.29,82.426a1.3,1.3,0,0,1-1.3-1.2,1.286,1.286,0,0,1,1.2-1.378c.52-.026,1.066-.052,1.586-.052a1.3,1.3,0,0,1,0,2.6c-.468,0-.936.026-1.4.052C240.368,82.426,240.316,82.426,240.29,82.426Z",
    transform: "translate(-238.987 -79.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9939",
    "data-name": "Group 9939",
    transform: "translate(50.814 22.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11607",
    "data-name": "Path 11607",
    d: "M196.729,90.715a1.3,1.3,0,0,1-.806-2.314,21.383,21.383,0,0,1,5.694-3.25,1.309,1.309,0,0,1,.936,2.444,19.742,19.742,0,0,0-5.044,2.86A1.4,1.4,0,0,1,196.729,90.715Z",
    transform: "translate(-195.44 -85.063)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9940",
    "data-name": "Group 9940",
    transform: "translate(42.874 29.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11608",
    "data-name": "Path 11608",
    d: "M169.736,138.966a1.275,1.275,0,0,1-1.066-.572,22.111,22.111,0,0,1,.494-25.4,1.3,1.3,0,0,1,2.106,1.534,19.446,19.446,0,0,0-.442,22.386,1.339,1.339,0,0,1-1.092,2.054Z",
    transform: "translate(-164.9 -112.462)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9941",
    "data-name": "Group 9941",
    transform: "translate(33.28 11.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11609",
    "data-name": "Path 11609",
    d: "M159.668,42.9a31.668,31.668,0,1,0,31.668,31.668A31.691,31.691,0,0,0,159.668,42.9Zm0,57.668a26,26,0,1,1,26-26A26.01,26.01,0,0,1,159.668,100.568Z",
    transform: "translate(-128 -42.9)",
    fill: "#aaadad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9942",
    "data-name": "Group 9942",
    transform: "translate(32.838 103.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11610",
    "data-name": "Path 11610",
    d: "M126.3,413.77a63.735,63.735,0,0,0,64.324,0V397H126.3Z",
    transform: "translate(-126.3 -397)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9943",
    "data-name": "Group 9943",
    transform: "translate(28.47 96.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11611",
    "data-name": "Path 11611",
    d: "M179.96,377.39H112.1a2.608,2.608,0,0,1-2.6-2.6V373.1a2.608,2.608,0,0,1,2.6-2.6h67.86a2.608,2.608,0,0,1,2.6,2.6v1.69A2.608,2.608,0,0,1,179.96,377.39Z",
    transform: "translate(-109.5 -370.5)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9944",
    "data-name": "Group 9944",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11612",
    "data-name": "Path 11612",
    d: "M65,130A65.009,65.009,0,0,1,19.032,19.032a65.009,65.009,0,0,1,91.936,91.936A64.584,64.584,0,0,1,65,130ZM65,2.6A62.4,62.4,0,1,0,127.4,65,62.483,62.483,0,0,0,65,2.6Z",
    transform: "translate(0 0)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9945",
    "data-name": "Group 9945",
    transform: "translate(31.512 101.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11613",
    "data-name": "Path 11613",
    d: "M154.688,420.08a64.977,64.977,0,0,1-32.838-8.892,1.311,1.311,0,0,1-.65-1.118V393.3a1.287,1.287,0,0,1,1.3-1.3h64.324a1.287,1.287,0,0,1,1.3,1.3v16.77a1.258,1.258,0,0,1-.65,1.118A64.648,64.648,0,0,1,154.688,420.08Zm-30.862-10.764a62.415,62.415,0,0,0,61.724,0V394.6H123.826Z",
    transform: "translate(-121.2 -392)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9946",
    "data-name": "Group 9946",
    transform: "translate(36.738 107.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11614",
    "data-name": "Path 11614",
    d: "M142.6,423.1a1.287,1.287,0,0,1-1.3-1.3v-8.5a1.3,1.3,0,1,1,2.6,0v8.5A1.3,1.3,0,0,1,142.6,423.1Z",
    transform: "translate(-141.3 -412)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9947",
    "data-name": "Group 9947",
    transform: "translate(27.17 95.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11615",
    "data-name": "Path 11615",
    d: "M176.26,374.99H108.4a3.9,3.9,0,0,1-3.9-3.9V369.4a3.9,3.9,0,0,1,3.9-3.9h67.86a3.9,3.9,0,0,1,3.9,3.9v1.69A3.9,3.9,0,0,1,176.26,374.99ZM108.4,368.1a1.287,1.287,0,0,0-1.3,1.3v1.69a1.287,1.287,0,0,0,1.3,1.3h67.86a1.287,1.287,0,0,0,1.3-1.3V369.4a1.287,1.287,0,0,0-1.3-1.3Z",
    transform: "translate(-104.5 -365.5)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9948",
    "data-name": "Group 9948",
    transform: "translate(46.826 110.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11616",
    "data-name": "Path 11616",
    d: "M183.272,424a3.168,3.168,0,0,0-3.172,3.172v12.662a63.931,63.931,0,0,0,6.318,1.534v-14.2A3.13,3.13,0,0,0,183.272,424Z",
    transform: "translate(-180.1 -424)",
    fill: "#aaadad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9949",
    "data-name": "Group 9949",
    transform: "translate(61.828 110.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11617",
    "data-name": "Path 11617",
    d: "M240.972,424a3.168,3.168,0,0,0-3.172,3.172v15.21c1.04.052,2.106.078,3.172.078s2.106-.026,3.172-.078v-15.21A3.168,3.168,0,0,0,240.972,424Z",
    transform: "translate(-237.8 -424)",
    fill: "#aaadad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9950",
    "data-name": "Group 9950",
    transform: "translate(76.83 110.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11618",
    "data-name": "Path 11618",
    d: "M298.672,424a3.168,3.168,0,0,0-3.172,3.172v14.2a62.2,62.2,0,0,0,6.318-1.534V427.172A3.146,3.146,0,0,0,298.672,424Z",
    transform: "translate(-295.5 -424)",
    fill: "#aaadad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9951",
    "data-name": "Group 9951",
    transform: "translate(45.552 108.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11619",
    "data-name": "Path 11619",
    d: "M182.818,438.968a.721.721,0,0,1-.234-.026c-2.158-.416-4.342-.936-6.448-1.56a1.311,1.311,0,0,1-.936-1.248V423.472a4.472,4.472,0,0,1,8.944,0v14.2a1.286,1.286,0,0,1-.468.988A1.4,1.4,0,0,1,182.818,438.968Zm-5.018-3.822c1.222.338,2.47.65,3.718.91v-12.61a1.872,1.872,0,1,0-3.744,0v11.7Z",
    transform: "translate(-175.2 -419)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9952",
    "data-name": "Group 9952",
    transform: "translate(60.528 108.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11620",
    "data-name": "Path 11620",
    d: "M237.272,440.06c-1.066,0-2.158-.026-3.224-.078a1.293,1.293,0,0,1-1.248-1.3v-15.21a4.472,4.472,0,1,1,8.944,0v15.21a1.293,1.293,0,0,1-1.248,1.3c-1.066.052-2.158.078-3.224.078Zm-1.872-2.626c1.248.026,2.47.026,3.718,0V423.472a1.872,1.872,0,1,0-3.744,0v13.962Z",
    transform: "translate(-232.8 -419)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9953",
    "data-name": "Group 9953",
    transform: "translate(75.53 108.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11621",
    "data-name": "Path 11621",
    d: "M291.8,438.968a1.226,1.226,0,0,1-.832-.312,1.371,1.371,0,0,1-.468-.988v-14.2a4.472,4.472,0,0,1,8.944,0v12.662a1.311,1.311,0,0,1-.936,1.248c-2.132.624-4.29,1.144-6.448,1.56C291.956,438.942,291.878,438.968,291.8,438.968Zm3.172-17.368a1.881,1.881,0,0,0-1.872,1.872v12.61c1.248-.26,2.5-.572,3.718-.91v-11.7A1.859,1.859,0,0,0,294.972,421.6Z",
    transform: "translate(-290.5 -419)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9954",
    "data-name": "Group 9954",
    transform: "translate(32.032 9.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11622",
    "data-name": "Path 11622",
    d: "M156.168,103.836a32.968,32.968,0,1,1,32.968-32.968A33.011,33.011,0,0,1,156.168,103.836Zm0-63.336a30.368,30.368,0,1,0,30.368,30.368A30.4,30.4,0,0,0,156.168,40.5Z",
    transform: "translate(-123.2 -37.9)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9955",
    "data-name": "Group 9955",
    transform: "translate(40.085 15.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11623",
    "data-name": "Path 11623",
    d: "M204.283,94.774a1.344,1.344,0,0,1-1.248-1.638A24.7,24.7,0,0,0,156.651,76.7a1.3,1.3,0,0,1-2.366-1.066,27.3,27.3,0,0,1,51.246,18.174A1.28,1.28,0,0,1,204.283,94.774Z",
    transform: "translate(-154.174 -59.7)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9956",
    "data-name": "Group 9956",
    transform: "translate(39.878 51.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11624",
    "data-name": "Path 11624",
    d: "M174.156,217.618a.507.507,0,0,1-.208-.026,27.139,27.139,0,0,1-20.462-15.99,1.3,1.3,0,0,1,2.392-1.04,24.617,24.617,0,0,0,18.512,14.456,1.3,1.3,0,0,1,1.066,1.508A1.357,1.357,0,0,1,174.156,217.618Z",
    transform: "translate(-153.376 -199.776)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9957",
    "data-name": "Group 9957",
    transform: "translate(73.222 49.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11625",
    "data-name": "Path 11625",
    d: "M288.977,193.719l-3.172-3.172A2.445,2.445,0,1,0,282.346,194l3.172,3.172a2.445,2.445,0,0,0,3.458-3.458Z",
    transform: "translate(-281.625 -189.825)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9958",
    "data-name": "Group 9958",
    transform: "translate(79.853 55.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11626",
    "data-name": "Path 11626",
    d: "M314.477,219.118l-3.172-3.172a2.445,2.445,0,0,0-3.458,3.458l3.172,3.172a2.432,2.432,0,0,0,3.458,0A2.48,2.48,0,0,0,314.477,219.118Z",
    transform: "translate(-307.125 -215.225)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9959",
    "data-name": "Group 9959",
    transform: "translate(86.456 62.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11627",
    "data-name": "Path 11627",
    d: "M339.876,244.519l-3.172-3.172a2.445,2.445,0,0,0-3.458,3.458l3.172,3.172a2.432,2.432,0,0,0,3.458,0A2.48,2.48,0,0,0,339.876,244.519Z",
    transform: "translate(-332.525 -240.625)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9960",
    "data-name": "Group 9960",
    transform: "translate(79.983 49.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11628",
    "data-name": "Path 11628",
    d: "M314.977,193.219l-3.172-3.172a2.445,2.445,0,0,0-3.458,3.458l3.172,3.172a2.445,2.445,0,0,0,3.458-3.458Z",
    transform: "translate(-307.625 -189.325)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9961",
    "data-name": "Group 9961",
    transform: "translate(86.586 55.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11629",
    "data-name": "Path 11629",
    d: "M340.377,218.619l-3.172-3.172a2.445,2.445,0,1,0-3.458,3.458l3.172,3.172a2.445,2.445,0,1,0,3.458-3.458Z",
    transform: "translate(-333.025 -214.725)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9962",
    "data-name": "Group 9962",
    transform: "translate(69.661 59.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11630",
    "data-name": "Path 11630",
    d: "M275.251,232.992l-3.146-3.146a2.445,2.445,0,0,0-3.458,3.458l3.172,3.172a2.432,2.432,0,0,0,3.458,0A2.488,2.488,0,0,0,275.251,232.992Z",
    transform: "translate(-267.925 -229.125)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9963",
    "data-name": "Group 9963",
    transform: "translate(69.791 52.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11631",
    "data-name": "Path 11631",
    d: "M275.777,207.019l-3.172-3.172a2.445,2.445,0,0,0-3.458,3.458l3.172,3.172a2.432,2.432,0,0,0,3.458,0A2.48,2.48,0,0,0,275.777,207.019Z",
    transform: "translate(-268.425 -203.125)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9964",
    "data-name": "Group 9964",
    transform: "translate(76.395 59.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11632",
    "data-name": "Path 11632",
    d: "M301.177,232.419,298,229.247a2.445,2.445,0,0,0-3.458,3.458l3.172,3.172a2.445,2.445,0,0,0,3.458-3.458Z",
    transform: "translate(-293.825 -228.525)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9965",
    "data-name": "Group 9965",
    transform: "translate(82.998 66.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11633",
    "data-name": "Path 11633",
    d: "M326.576,257.819l-3.172-3.172a2.445,2.445,0,0,0-3.458,3.458l3.172,3.172a2.445,2.445,0,1,0,3.458-3.458Z",
    transform: "translate(-319.225 -253.925)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9966",
    "data-name": "Group 9966",
    transform: "translate(71.968 48.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11634",
    "data-name": "Path 11634",
    d: "M283.69,195.534a3.759,3.759,0,0,1-2.652-1.092l-3.146-3.146a3.744,3.744,0,0,1,2.652-6.4,3.759,3.759,0,0,1,2.652,1.092l3.172,3.172a3.735,3.735,0,0,1,0,5.278,3.82,3.82,0,0,1-2.678,1.092Zm-3.146-8.034a1.14,1.14,0,0,0-.806,1.95l3.172,3.172a1.14,1.14,0,1,0,1.612-1.612l-3.172-3.172A1.24,1.24,0,0,0,280.544,187.5Z",
    transform: "translate(-276.8 -184.9)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9967",
    "data-name": "Group 9967",
    transform: "translate(78.546 54.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11635",
    "data-name": "Path 11635",
    d: "M309.016,220.86a3.805,3.805,0,0,1-2.652-1.092l-3.172-3.172a3.714,3.714,0,0,1-1.092-2.652,3.759,3.759,0,0,1,1.092-2.652,3.714,3.714,0,0,1,2.652-1.092,3.805,3.805,0,0,1,2.652,1.092l3.172,3.172a3.744,3.744,0,0,1-2.652,6.4Zm-3.146-8.034a1.14,1.14,0,0,0-.806,1.95l3.172,3.172a1.14,1.14,0,1,0,1.612-1.612l-3.172-3.172A1.24,1.24,0,0,0,305.87,212.826Z",
    transform: "translate(-302.1 -210.2)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9968",
    "data-name": "Group 9968",
    transform: "translate(85.15 61.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11636",
    "data-name": "Path 11636",
    d: "M334.416,246.434a3.805,3.805,0,0,1-2.652-1.092l-3.172-3.172a3.732,3.732,0,1,1,5.278-5.278l3.172,3.172a3.714,3.714,0,0,1,1.092,2.652,3.759,3.759,0,0,1-1.092,2.652A3.694,3.694,0,0,1,334.416,246.434Zm-3.146-8.06a1.122,1.122,0,0,0-.806.338,1.146,1.146,0,0,0,0,1.612l3.172,3.172a1.14,1.14,0,1,0,1.612-1.612l-3.172-3.172A1.24,1.24,0,0,0,331.27,238.374Z",
    transform: "translate(-327.5 -235.8)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9969",
    "data-name": "Group 9969",
    transform: "translate(78.728 47.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11637",
    "data-name": "Path 11637",
    d: "M309.69,195.034a3.805,3.805,0,0,1-2.652-1.092l-3.146-3.172a3.732,3.732,0,0,1,5.278-5.278l3.172,3.172a3.766,3.766,0,0,1,0,5.3A3.9,3.9,0,0,1,309.69,195.034ZM306.518,187a1.122,1.122,0,0,0-.806.338,1.146,1.146,0,0,0,0,1.612l3.172,3.172a1.14,1.14,0,1,0,1.612-1.612l-3.172-3.172A1.081,1.081,0,0,0,306.518,187Z",
    transform: "translate(-302.8 -184.4)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9970",
    "data-name": "Group 9970",
    transform: "translate(85.306 54.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11638",
    "data-name": "Path 11638",
    d: "M335.016,220.434a3.759,3.759,0,0,1-2.652-1.092l-3.172-3.172a3.741,3.741,0,0,1,5.3-5.278l3.172,3.172a3.766,3.766,0,0,1,0,5.3A3.9,3.9,0,0,1,335.016,220.434Zm-3.172-8.034a1.144,1.144,0,0,0-.806,1.95l3.172,3.172a1.14,1.14,0,1,0,1.612-1.612l-3.172-3.172A1.043,1.043,0,0,0,331.844,212.4Z",
    transform: "translate(-328.1 -209.8)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9971",
    "data-name": "Group 9971",
    transform: "translate(68.354 58.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11639",
    "data-name": "Path 11639",
    d: "M269.816,234.734a3.759,3.759,0,0,1-2.652-1.092l-3.172-3.172a3.741,3.741,0,0,1,5.3-5.278l3.172,3.172a3.735,3.735,0,0,1,0,5.278A3.7,3.7,0,0,1,269.816,234.734Zm-3.172-8.034a1.144,1.144,0,0,0-.806,1.95l3.172,3.172a1.14,1.14,0,0,0,1.612-1.612l-3.172-3.172A1.141,1.141,0,0,0,266.644,226.7Z",
    transform: "translate(-262.9 -224.1)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9972",
    "data-name": "Group 9972",
    transform: "translate(68.51 51.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11640",
    "data-name": "Path 11640",
    d: "M270.416,208.76a3.739,3.739,0,0,1-2.652-1.092l-3.172-3.172a3.744,3.744,0,0,1,2.652-6.4,3.805,3.805,0,0,1,2.652,1.092l3.172,3.172a3.757,3.757,0,0,1-2.652,6.4Zm-3.172-8.034a1.14,1.14,0,0,0-.806,1.95l3.172,3.172a1.14,1.14,0,0,0,1.612-1.612l-3.172-3.172A1.043,1.043,0,0,0,267.244,200.726Z",
    transform: "translate(-263.5 -198.1)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9973",
    "data-name": "Group 9973",
    transform: "translate(75.114 58.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11641",
    "data-name": "Path 11641",
    d: "M295.816,234.16a3.805,3.805,0,0,1-2.652-1.092l-3.172-3.172a3.744,3.744,0,0,1,2.652-6.4,3.805,3.805,0,0,1,2.652,1.092l3.172,3.172a3.714,3.714,0,0,1,1.092,2.652,3.759,3.759,0,0,1-1.092,2.652A3.8,3.8,0,0,1,295.816,234.16Zm-3.172-8.034a1.14,1.14,0,0,0-.806,1.95l3.172,3.172a1.14,1.14,0,1,0,1.612-1.612l-3.172-3.172A1.042,1.042,0,0,0,292.644,226.126Z",
    transform: "translate(-288.9 -223.5)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9974",
    "data-name": "Group 9974",
    transform: "translate(81.718 64.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11642",
    "data-name": "Path 11642",
    d: "M321.216,259.634a3.759,3.759,0,0,1-2.652-1.092l-3.172-3.172a3.741,3.741,0,0,1,5.3-5.278l3.172,3.172a3.766,3.766,0,0,1,0,5.3A3.9,3.9,0,0,1,321.216,259.634Zm-3.172-8.034a1.144,1.144,0,0,0-.806,1.95l3.172,3.172a1.14,1.14,0,1,0,1.612-1.612l-3.172-3.172A1.141,1.141,0,0,0,318.044,251.6Z",
    transform: "translate(-314.3 -249)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9975",
    "data-name": "Group 9975",
    transform: "translate(52.712 51.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11643",
    "data-name": "Path 11643",
    d: "M218.536,209.432l-7.93-7.124a1.2,1.2,0,0,0,.182-.182,2.687,2.687,0,1,0-3.978-3.614,2.73,2.73,0,0,0-.39,3.068,2.621,2.621,0,0,0-2.99.7,2.687,2.687,0,1,0,3.978,3.614c.052-.078.13-.13.182-.208l7.9,7.15Z",
    transform: "translate(-202.738 -197.638)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9976",
    "data-name": "Group 9976",
    transform: "translate(51.436 50.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11644",
    "data-name": "Path 11644",
    d: "M211.888,210.344a1.2,1.2,0,0,1-.858-.338l-7.02-6.344a4,4,0,0,1-5.148-6.032,4.1,4.1,0,0,1,2.366-1.274,3.951,3.951,0,0,1,3.77-3.77,4.06,4.06,0,0,1,2.886,1.014,3.992,3.992,0,0,1,.884,4.784l7.02,6.344a1.2,1.2,0,0,1,.416.91,1.269,1.269,0,0,1-.338.936L212.85,209.9A1.331,1.331,0,0,1,211.888,210.344Zm-7.93-9.75a1.442,1.442,0,0,1,.884.338l6.942,6.266,1.274-1.4-6.942-6.266a1.32,1.32,0,0,1,0-1.924l.1-.1a1.4,1.4,0,0,0-.1-1.976,1.435,1.435,0,0,0-1.014-.364,1.416,1.416,0,0,0-1.17,2.054,1.3,1.3,0,0,1-.182,1.482,1.279,1.279,0,0,1-1.456.338,1.4,1.4,0,1,0,.52,2.236c.026-.026.052-.078.1-.1a1.265,1.265,0,0,1,.91-.52A.168.168,0,0,1,203.958,200.594Z",
    transform: "translate(-197.83 -192.581)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9977",
    "data-name": "Group 9977",
    transform: "translate(65.494 63.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11645",
    "data-name": "Path 11645",
    d: "M267.734,248.1,254.916,243l-3.016,3.328,6.37,12.246A8.011,8.011,0,0,0,259.8,260.6a4.372,4.372,0,0,1,3.406-1.612,4.438,4.438,0,0,1,4.264,3.224,7.442,7.442,0,0,0,3.068-2.054A7.561,7.561,0,0,0,267.734,248.1Z",
    transform: "translate(-251.9 -243)",
    fill: "#ff8939"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9978",
    "data-name": "Group 9978",
    transform: "translate(64.197 61.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11646",
    "data-name": "Path 11646",
    d: "M263.756,259.758a1.208,1.208,0,0,1-.6-.156,1.346,1.346,0,0,1-.65-.806,3.109,3.109,0,0,0-5.408-1.144,1.292,1.292,0,0,1-1.872.13,8.892,8.892,0,0,1-1.794-2.366l-6.37-12.246a1.3,1.3,0,0,1,.182-1.482l3.016-3.328a1.279,1.279,0,0,1,1.456-.338l12.818,5.1a8.846,8.846,0,0,1,3.276,14.144,8.706,8.706,0,0,1-3.614,2.418,1.214,1.214,0,0,1-.442.078Zm-4.238-5.824a5.764,5.764,0,0,1,4.914,2.782,6.379,6.379,0,0,0,1.456-1.2,6.179,6.179,0,0,0,1.456-5.59,6.1,6.1,0,0,0-3.77-4.368L251.562,240.8l-1.794,2,5.954,11.44a4.544,4.544,0,0,0,.468.754A5.64,5.64,0,0,1,259.518,253.934Z",
    transform: "translate(-246.911 -237.925)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9979",
    "data-name": "Group 9979",
    transform: "translate(29.614 34.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11647",
    "data-name": "Path 11647",
    d: "M137.56,135.12H116.422a2.522,2.522,0,1,0,0,5.044H137.56a3.129,3.129,0,0,0,3.12,3.12h5.512a5.642,5.642,0,1,0,0-11.284H140.68A3.112,3.112,0,0,0,137.56,135.12Z",
    transform: "translate(-113.9 -132)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9980",
    "data-name": "Group 9980",
    transform: "translate(28.288 32.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11648",
    "data-name": "Path 11648",
    d: "M142.418,140.784h-5.512a4.481,4.481,0,0,1-4.238-3.12H112.622a3.822,3.822,0,1,1,0-7.644h20.046a4.432,4.432,0,0,1,4.238-3.12h5.512a6.942,6.942,0,0,1,0,13.884Zm-29.77-8.138a1.222,1.222,0,1,0,0,2.444h21.138a1.287,1.287,0,0,1,1.3,1.3,1.809,1.809,0,0,0,1.82,1.82h5.512a4.342,4.342,0,0,0,0-8.684h-5.512a1.809,1.809,0,0,0-1.82,1.82,1.287,1.287,0,0,1-1.3,1.3Z",
    transform: "translate(-108.8 -126.9)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9981",
    "data-name": "Group 9981",
    transform: "translate(4.966 33.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11649",
    "data-name": "Path 11649",
    d: "M44.684,128h-20.8A63.674,63.674,0,0,0,19.1,138.374H31.554V141a6.348,6.348,0,0,0,7.332,6.266l8.658-1.378a6.366,6.366,0,0,0,5.356-6.266V136.19A8.228,8.228,0,0,0,44.684,128Z",
    transform: "translate(-19.1 -128)",
    fill: "#ffc5b3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9982",
    "data-name": "Group 9982",
    transform: "translate(3.663 31.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11650",
    "data-name": "Path 11650",
    d: "M34.189,144.918a7.8,7.8,0,0,1-4.966-1.82,7.654,7.654,0,0,1-2.678-5.8v-1.326H15.391a1.355,1.355,0,0,1-1.066-.546,1.3,1.3,0,0,1-.156-1.2,62.958,62.958,0,0,1,4.888-10.582,1.311,1.311,0,0,1,1.118-.65h20.8a9.51,9.51,0,0,1,9.49,9.49v3.432a7.606,7.606,0,0,1-6.448,7.54l-8.632,1.378A9.545,9.545,0,0,1,34.189,144.918Zm-16.926-11.57H27.845a1.287,1.287,0,0,1,1.3,1.3V137.3a5.038,5.038,0,0,0,5.824,4.966l8.658-1.378a4.986,4.986,0,0,0,4.238-4.966V132.49a6.9,6.9,0,0,0-6.89-6.89H20.929A62.154,62.154,0,0,0,17.263,133.348Z",
    transform: "translate(-14.088 -123)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9983",
    "data-name": "Group 9983",
    transform: "translate(21.32 37.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11651",
    "data-name": "Path 11651",
    d: "M94.22,148.59a1.287,1.287,0,0,1-1.3-1.3,1.687,1.687,0,0,0-1.69-1.69H83.3a1.3,1.3,0,1,1,0-2.6h7.93a4.294,4.294,0,0,1,4.29,4.29A1.3,1.3,0,0,1,94.22,148.59Z",
    transform: "translate(-82 -143)",
    fill: "#ffece9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9984",
    "data-name": "Group 9984",
    transform: "translate(31.304 44.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11652",
    "data-name": "Path 11652",
    d: "M121.7,180.592a1.287,1.287,0,0,1-1.3-1.3V174.3a1.3,1.3,0,1,1,2.6,0v4.992A1.287,1.287,0,0,1,121.7,180.592Z",
    transform: "translate(-120.4 -173)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9985",
    "data-name": "Group 9985",
    transform: "translate(25.48 46.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11653",
    "data-name": "Path 11653",
    d: "M99.3,184.462a1.287,1.287,0,0,1-1.3-1.3V178.3a1.3,1.3,0,1,1,2.6,0v4.862A1.287,1.287,0,0,1,99.3,184.462Z",
    transform: "translate(-98 -177)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9986",
    "data-name": "Group 9986",
    transform: "translate(79.144 36.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11654",
    "data-name": "Path 11654",
    d: "M306.584,143.51a1.22,1.22,0,0,1-.91-.39l-.884-.884a1.305,1.305,0,1,1,1.846-1.846l.884.884a1.287,1.287,0,0,1,0,1.846A1.22,1.22,0,0,1,306.584,143.51Z",
    transform: "translate(-304.4 -140)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9987",
    "data-name": "Group 9987",
    transform: "translate(71.942 29.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11655",
    "data-name": "Path 11655",
    d: "M281.77,118.8a1.22,1.22,0,0,1-.91-.39l-3.77-3.77a1.305,1.305,0,1,1,1.846-1.846l3.77,3.77a1.287,1.287,0,0,1,0,1.846A1.319,1.319,0,0,1,281.77,118.8Z",
    transform: "translate(-276.7 -112.4)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9988",
    "data-name": "Group 9988",
    transform: "translate(78.26 43.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11656",
    "data-name": "Path 11656",
    d: "M303.184,169.01a1.22,1.22,0,0,1-.91-.39l-.884-.884a1.305,1.305,0,1,1,1.846-1.846l.884.884a1.287,1.287,0,0,1,0,1.846A1.319,1.319,0,0,1,303.184,169.01Z",
    transform: "translate(-301 -165.5)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9989",
    "data-name": "Group 9989",
    transform: "translate(69.81 34.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11657",
    "data-name": "Path 11657",
    d: "M274.818,140.644a1.22,1.22,0,0,1-.91-.39l-5.018-5.018a1.305,1.305,0,1,1,1.846-1.846l5.018,5.018a1.287,1.287,0,0,1,0,1.846A1.32,1.32,0,0,1,274.818,140.644Z",
    transform: "translate(-268.5 -133)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9990",
    "data-name": "Group 9990",
    transform: "translate(16.172 37.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11658",
    "data-name": "Path 11658",
    d: "M64.488,145.6H63.5a1.3,1.3,0,1,1,0-2.6h.988a1.3,1.3,0,1,1,0,2.6Z",
    transform: "translate(-62.2 -143)",
    fill: "#ffece9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9991",
    "data-name": "Group 9991",
    transform: "translate(78.702 73.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11659",
    "data-name": "Path 11659",
    d: "M304,284.442a1.287,1.287,0,0,1-1.3-1.3V282.7a1.3,1.3,0,1,1,2.6,0v.442A1.287,1.287,0,0,1,304,284.442Z",
    transform: "translate(-302.7 -281.4)",
    fill: "#1c1d21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9992",
    "data-name": "Group 9992",
    transform: "translate(71.76 69.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11660",
    "data-name": "Path 11660",
    d: "M277.3,268.842a1.287,1.287,0,0,1-1.3-1.3V267.1a1.3,1.3,0,1,1,2.6,0v.442A1.3,1.3,0,0,1,277.3,268.842Z",
    transform: "translate(-276 -265.8)",
    fill: "#1c1d21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodPopup);
export default __webpack_public_path__ + "static/media/food-popup.650e0f136b041597872c4cf2a511f0eb.svg";
export { ForwardRef as ReactComponent };